import { render } from "./DirectiveReauthPolicyPage.vue?vue&type=template&id=f9ab5274&scoped=true"
import script from "./DirectiveReauthPolicyPage.vue?vue&type=script&lang=js"
export * from "./DirectiveReauthPolicyPage.vue?vue&type=script&lang=js"

import "./DirectiveReauthPolicyPage.vue?vue&type=style&index=0&id=f9ab5274&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9ab5274"]])

export default __exports__